import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import {
  fetchInstanceListProgramApi,
  fetchNextProgramApi,
  fetchPrevProgramApi,
  fetchProgramDetailsApi,
  fetchProgramInstanceDetailsApi,
  fetchProgramsListApi,
  fetchWebsiteApi,
  fetchProgramMenuApi,
  fetchTopFiveProgramsApi,
  fetchSeeMoreApiWebsite
} from '@/service'

export const useProgramsStore = defineStore('programs', () => {
  const programsList = ref({})
  const programBanner = ref({})
  const programMenu = ref([])
  const programTopFive = ref([])
  const programsItems = computed(() => programsList.value.items)
  const programDetail = ref({})
  const programSeeMore = ref({})
  const otherEmissions = ref([])
  const currentOccurrenceProgram = ref({})
  const nextOccurrenceProgram = ref(null)
  const prevOccurrenceProgram = ref(null)

  const fetchNextOccurrenceProgram = async (id) => {
    return fetchNextProgramApi(id).then((response) => {
      nextOccurrenceProgram.value = response
      return Promise.resolve(response)
    })
  }

  const fetchPrevOccurrenceProgram = async (id) => {
    return fetchPrevProgramApi(id).then((response) => {
      prevOccurrenceProgram.value = response
      return Promise.resolve(response)
    })
  }

  const fetchCurrentOccurrenceProgram = async (id) => {
    return fetchProgramInstanceDetailsApi(id).then((response) => {
      currentOccurrenceProgram.value = response
      return Promise.resolve(response)
    })
  }

  const fetchInstanceListProgram = async (id, occurrenceIdsNot) => {
    return fetchInstanceListProgramApi(id, occurrenceIdsNot).then((response) => {
      otherEmissions.value = response
      return Promise.resolve(response)
    })
  }
  const fetchProgramDetails = async (id) => {
    return fetchProgramDetailsApi(id).then((response) => {
      programDetail.value = response
      return Promise.resolve(response)
    })
  }

  const fetchProgramsList = async (station_code, date) => {
    return fetchProgramsListApi(station_code, date, 1).then((response) => {
      programsList.value = response
      return Promise.resolve(response)
    })
  }

  const fetchProgramBanner = async (id) => {
    return fetchWebsiteApi(id).then((response) => {
      programBanner.value = response
      return Promise.resolve(response)
    })
  }
  const fetchProgramMenu = async (id) => {
    return fetchProgramMenuApi(id).then((response) => {
      programMenu.value = response
      return Promise.resolve(response)
    })
  }

  const fetchTopFiveProgram = async (id) => {
    return fetchTopFiveProgramsApi(id).then((response) => {
      programTopFive.value = response
      return Promise.resolve(response)
    })
  }

  const fetchSeeMoreProgram = async (id) => {
    return fetchSeeMoreApiWebsite(id).then((response) => {
      programSeeMore.value = response
      return Promise.resolve(response)
    })
  }

  return {
    programsList,
    programBanner,
    programsItems,
    programDetail,
    otherEmissions,
    currentOccurrenceProgram,
    nextOccurrenceProgram,
    prevOccurrenceProgram,
    fetchNextOccurrenceProgram,
    fetchPrevOccurrenceProgram,
    fetchCurrentOccurrenceProgram,
    fetchInstanceListProgram,
    fetchProgramDetails,
    fetchProgramsList,
    fetchProgramBanner,
    fetchProgramMenu,
    programMenu,
    programTopFive,
    fetchTopFiveProgram,
    fetchSeeMoreProgram,
    programSeeMore
  }
})
